import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AgGridProjectRoleTemplatesSettings } from './AgGridProjectRoleTemplatesSettings';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectGrouprolesButtonRendererComponent } from '../project-grouproles-button-renderer/project-grouproles-button-renderer.component';
import { TenantGroupRoleDto } from 'projects/shared/src/lib/models/TenantDto';
import { MatSelect } from '@angular/material/select';
import { ProjectGroupRoleDto } from 'projects/shared/src/lib/models/projectgrouprole';
import { AddProjectGrouproleDialogComponent } from '../project-role/add-project-grouprole-dialog/add-project-grouprole-dialog.component';

@Component({
  selector: 'project-role-templates',
  templateUrl: './project-role-templates.component.html',
  styleUrls: ['./project-role-templates.component.scss']
})
export class ProjectRoleTemplatesComponent implements OnInit {

  @ViewChild('matRef') matRef!: MatSelect;

  rowData: ProjectGroupRoleDto[] = [];
  // permissions: TenantPermissionDto[] = []

  // groupRoles:TenantGroupRoleDto[] = [];
  // groupRolesToAssign:TenantGroupRoleDto[] = [];
  // groupRolesToDisplay:TenantGroupRoleDto[] = [];
  // userForm!: FormGroup;
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter: GenericFilter = new GenericFilter();
  aggridSettings!:AgGridProjectRoleTemplatesSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  _tenantName: string = '';


    constructor(
      private route: ActivatedRoute,
      private formBuilder: FormBuilder,
      public dialog: MatDialog,
      public translate:TranslateService,
      private notificationService: NotificationService,
      private tenantService: TenantService,
      // private permissionService: PermissionsService
    ) { }
  
  

  ngOnInit() {
      this._tenantName = this.tenantService.currentTenantName;

      this.filter = new GenericFilter();
      this.aggridSettings = new AgGridProjectRoleTemplatesSettings(this.translate);
  
      this.frameworkComponents = {
        buttonRenderer: ProjectGrouprolesButtonRendererComponent
      }
  
      //this.gridOptions = agGridUsersSettings;
      this.gridOptions = this.aggridSettings.agGridProjectRoleTemplatesSettings;
  
      this.ds = {
        rowCount: 0,
        getRows: (params: IGetRowsParams) => {
  
          this.filter.className = 'TenantProject';
          this.filter.startRow = params.startRow;
          this.filter.endRow = params.endRow;
          this.filter.sortItems = params.sortModel;
          this.filter.clientFilters = params.filterModel;
  
          this.gridApi.showLoadingOverlay();
          this.isLoadingResults = true;
  
          //getTenantGroupRoles
          this.tenantService.getProjectGroupRoleTemplates(this._tenantName, this.filter).subscribe({
            next: (grouproles) => {
              this.rowData = grouproles;
              this.rowData = this.rowData.slice(params.startRow, params.endRow);
              console.log("---------------> project-role-templates", this.rowData)
              let lastRow = -1;
  
              if (grouproles.length <= params.endRow) {
                lastRow = grouproles.length;
              }
              params.successCallback(this.rowData, lastRow);
                // Flip flag to show that loading has finished.
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
              this.resultsLength = this.rowData.length;
  
              this.gridApi.hideOverlay();
            
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              // Catch if the Squirrel API has reached its rate limit. Return empty data.
              //this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
              //console.log("------> error: ", error.error.developerMessage)
              this.notificationService.info("", error.error.developerMessage.Message)
            }
          })

        }
      }
    }

    onGridReady(params: any) {
      console.log("-----------------------> params.api = ",params.api);
      this.gridApi = params.api;    
      this.gridApi.sizeColumnsToFit();    
      this.gridApi.setDatasource(this.ds)
      console.log("-----------------------> nach setDatasource");
    }

    addProjectGroupRole() {

    // const dialogRef = this.dialog.open(UserGroupRolesDialogComponent, { width: '500px', data: {roleId: rowData[0].id,
    //                                                                                             roleName: rowData[0].name,
    //                                                                                             projectId:rowData[0].projectId } });



        const dialogRef = this.dialog.open(AddProjectGrouproleDialogComponent, { width: '800px', data: true });
        dialogRef.afterClosed().subscribe((result: any) => { 

          if (result !== undefined) {
            let projectGroupRole = new ProjectGroupRoleDto;
            projectGroupRole.name = result.name;
            projectGroupRole.permissions = result.permissions;
            projectGroupRole.isforadmin = result.isforadmin;

            let db:string = this.tenantService.currentTenantName;
            this.tenantService.createProjectGroupRoleTemplate(projectGroupRole, this.tenantService.currentTenantName).subscribe({
              next: (projectGroupRole: ProjectGroupRoleDto) => {
                // let pgr = new ProjectGroupRoleDto;
                // pgr.id = projectGroupRole.id;
                // pgr.name = projectGroupRole.name;
                // pgr.projectId = projectGroupRole.projectId
        
                this.rowData.splice(2, 0, projectGroupRole);
                this.rowData.push(projectGroupRole);
                this.gridApi.refreshInfiniteCache();
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${projectGroupRole.name} - ${this.translate.data["ADDPROJECTGROUPROLE"]} `);
              },
              error: () => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEERROR"]} - ${projectGroupRole.name}`)
            })
              }
        },
        //error
      );
    }
    
    // saveValues(values: any) {

    //   console.log("values = ", values)
    //   this.groupRolesToAssign = values;

    // }

    // add() {
    //   if (this.userForm.valid) {
    //     // let data = {roles: this.userForm.value};
    //     // console.log("-------> selected roles: ", this.groupRolesToAssign)
    //     this.groupRolesToAssign.forEach((role: TenantGroupRoleDto) => {
    //       let tenantGroupRoleUser = new TenantGroupRoleUserDto;
    //       tenantGroupRoleUser.roleId = role.id;
    //       tenantGroupRoleUser.name = role.name;
    //       tenantGroupRoleUser.userId = this.user.id;
    //       tenantGroupRoleUser.userName = this.user.userName;
    //       this.tenantService.createTenantGroupRoleUser(this._tenantName, tenantGroupRoleUser).subscribe({
    //         next: (data) => {
    //           this.rowData.splice(2, 0, role);
    //           this.rowData.push(role);
    //           this.gridApi.refreshInfiniteCache();
    //           this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEASSIGNED"]}`);
    //         },
    //         error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
    //       });



    //     })
    //     // let data = {userDto: this.userForm.value, subSquirrels: this.subSquirrels};
    //     // this._dialogRef.close(this.userForm.value);
    //   }
    //   else{
    //     this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    //   }
    //   //this.userForm.reset({ userRoles: null });
    //   this.clear();
    // }

  }


